const DEV_ENV = "dev";
const PROD_ENV = "prod";
const B2B_PROD_ENV = "b2bProd";
const TEST_ENV = "staging";
const APP_ENV = B2B_PROD_ENV;

var SHOW_DISABLE_API_AND_ACTIVATE_BUTTON = false;

var API_ADMIN_URL = (APP_ENV === DEV_ENV) ? "http://localhost:5200" :
(APP_ENV === TEST_ENV) ? "https://staging-admin-server.appspot.com"
    :"https://admin-manager-server.appspot.com";

var TRACKING_SERVER_URL = (APP_ENV === DEV_ENV) ? "http://localhost:4000" :
    (APP_ENV === TEST_ENV) ? "https://staging-customer-website.appspot.com"
    :"https://qwikbus.co";


var API_TRAVELS_URL = (APP_ENV === DEV_ENV) ? "http://localhost:4000" :
    (APP_ENV === TEST_ENV) ? "https://staging-agent-server.appspot.com"
    :"https://srms-travels-server.qwikbus.co.in";

const API_B2B_ADMIN_BASE_URL = (APP_ENV === DEV_ENV) ? "http://localhost:5200" :
    (APP_ENV === TEST_ENV) ? "https://staging-admin-server.appspot.com" :
        "https://b2b-travels-admin.appspot.com";

var API_NORTH_ADMIN_URL = (APP_ENV === DEV_ENV) ? "http://localhost:5300" :
    (APP_ENV === TEST_ENV) ? "https://staging-admin-server.appspot.com" :
        "https://north-admin-server.appspot.com";

const ACCESS_CODE_STORAGE_KEY = 'hbdcjxnfdkckcbjxnfdcsbxnkfuducosl3190';

if (APP_ENV == B2B_PROD_ENV) {
  SHOW_DISABLE_API_AND_ACTIVATE_BUTTON = false;
  API_ADMIN_URL = "https://b2b-travels-admin.appspot.com";
  TRACKING_SERVER_URL = "https://qwikbus.co";
  API_TRAVELS_URL = "https://b2b-travels-server.qwikbus.co.in";
}

module.exports = {
  SHOW_DISABLE_API_AND_ACTIVATE_BUTTON,
  API_ADMIN_URL,
  API_TRAVELS_URL,
  TRACKING_SERVER_URL,
  ACCESS_CODE_STORAGE_KEY,
  API_B2B_ADMIN_BASE_URL,
  APP_ENV,
  DEV_ENV,
  API_NORTH_ADMIN_URL
}
